import type { Locale } from "../shared/types";

export function text(locale: Locale, tr: string, en: string): string {
  return locale === "tr" ? tr : en;
}

export function Brand({ compact = false }: { compact?: boolean }) {
  return (
    <a className={`brand ${compact ? "brand--compact" : ""}`} href={compact ? "/admin?view=events" : "https://echosedu.com"} aria-label="Echos Education">
      <img src={compact ? "/echos-logo-dark.png" : "https://files.echosedu.com/echos_new_logo_red.png"} alt="Echos Education" />
    </a>
  );
}

export function LanguageSwitch({ locale, onChange }: { locale: Locale; onChange: (locale: Locale) => void }) {
  return (
    <div className="language-switch" aria-label="Language">
      <button className={locale === "tr" ? "active" : ""} onClick={() => onChange("tr")} type="button">TR</button>
      <span aria-hidden="true" />
      <button className={locale === "en" ? "active" : ""} onClick={() => onChange("en")} type="button">EN</button>
    </div>
  );
}

export function Spinner({ label }: { label: string }) {
  return <div className="spinner-wrap" role="status"><span className="spinner" />{label}</div>;
}

export function StatusBadge({ status, locale }: { status: string; locale: Locale }) {
  const label = status === "confirmed"
    ? text(locale, "Katılıyor", "Confirmed")
    : status === "declined"
      ? text(locale, "Katılamıyor", "Declined")
      : text(locale, "Yanıt bekleniyor", "No answer");
  return <span className={`status-badge status-badge--${status}`}>{label}</span>;
}

export function PublicRegistrationBadge({ at, locale }: { at?: string | null; locale: Locale }) {
  if (!at) return null;
  const date = new Date(at).toLocaleString(locale === "tr" ? "tr-TR" : "en-GB");
  return <span className="public-registration-badge" title={text(locale, `İlk herkese açık kayıt: ${date}`, `First public registration: ${date}`)}>
    {text(locale, "Herkese açık kayıt", "Public registration")}
  </span>;
}
